import { withInstall } from '@/utils'
import Editor from './src/index.vue'
export default withInstall(Editor)
